<template>
  <div id="app">
    <router-view />
    <online-service v-if="!prefix" />
  </div>
</template>

<script>
import { updateThemeColor } from '@/utils/primaryColor'
import OnlineService from '@/components/OnlineService/index.vue'
import { PREFIX } from '@/utils/host'
export default {
  name: 'App',
  components: { OnlineService },
  data() {
    return {
      prefix: ''
    }
  },
  created() {
    // var link = document.querySelector('link[rel*="icon"]')
    // link.href = 'https://yldfiles.geekyum.com/fe/imgs/topasia_favicon.ico'
    document.body.style.setProperty('--geek-color-primary', '#1B99E7')
    updateThemeColor('#1B99E7')
    this.prefix = PREFIX
  }
}
</script>
